export default __webpack_public_path__ + "static/media/LogoUwr.15563149.png";